/**
 * AutonumberFieldType — automatyczny numer (np. FV/2026/0001). Storage: PG INTEGER.
 *
 * Read-only z perspektywy usera — wartość generowana przez backend (sequencja per moduł).
 * MVP: prosty input readonly. Po MVP: format z prefix/padding (np. „FV/2026/0042").
 */

import type { FieldInputProps, FieldTypeDefinition } from '../FieldRegistry';

function AutonumberInput({ field, value }: FieldInputProps) {
  const display = value === null || value === undefined ? '— auto —' : String(value);
  return (
    <input
      type="text"
      value={display}
      readOnly
      data-testid={`field-${field.slug}-input`}
      className="w-full rounded-md border border-border-primary bg-bg-tertiary px-3 py-2 text-sm font-mono text-text-secondary"
    />
  );
}

export const AutonumberFieldType: FieldTypeDefinition = {
  type: 'autonumber',
  renderInput: (props) => <AutonumberInput {...props} />,
  renderCell: (_field, value) => (value == null ? '' : String(value)),
  defaultValue: null,
};
